// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"navTabs_wrapper___7CT_","tabs":"navTabs_tabs__141EN","tab_selected":"navTabs_tab_selected__7f402"};